export default {
  '@type': 'MerchantReturnPolicy',
  'applicableCountry': 'LU',
  'merchantReturnLink': 'https://www.timberland.lu/fr-lu/aide-et-contact/retours',
  'returnPolicyCategory': 'https://schema.org/MerchantReturnFiniteReturnWindow',
  'returnMethod': 'https://schema.org/ReturnByMail',
  'merchantReturnDays': 30
}
